import * as React from 'react';

import * as Leads from 'nutshell-core/leads';

import {Button} from 'shells/button/button';
import {Link} from 'shells/link/link';
import {SectionLabel} from 'shells/typography/section-label';

import styles from './stages-carousel-empty.module.css';

type Props = {
    leadId: string;
    canAccessSetup: boolean;
};

export function StagesCarouselEmpty(props: Props) {
    // In rare cases, instances actually have a stageset
    // but some older leads don't have any. We want them
    // to be allowed to have a stageset.
    const defaultStagesetId = NutshellFrontendSettings.defaultStagesetId;

    return (
        <div className={styles['stages-carousel-empty']}>
            <SectionLabel>Stages</SectionLabel>
            <div>
                {defaultStagesetId ? (
                    // This class has some LESS baggage associated with it,
                    // so we need to inline this to make everyone happy.
                    <div className='big-empty-placeholder' style={{display: 'block'}}>
                        <div className='icon' />
                        <div className='title'>This lead doesn’t have a pipeline.</div>
                        <Button
                            variant='text-primary'
                            onClick={() => selectDefaultStageset(props.leadId, defaultStagesetId)}
                        >
                            Use your default pipeline
                        </Button>
                    </div>
                ) : (
                    // This class has some LESS baggage associated with it,
                    // so we need to inline this to make everyone happy.
                    <div className='big-empty-placeholder' style={{display: 'block'}}>
                        <div className='icon' />
                        <div className='title'>No stages defined</div>
                        <div className='description'>
                            Use stages to track the value and speed at which your leads move through
                            the funnel.
                        </div>
                        {props.canAccessSetup ? (
                            <Link size='small' variant='primary' href='/setup/process-builder'>
                                Set up your company’s stages
                            </Link>
                        ) : undefined}
                    </div>
                )}
            </div>
        </div>
    );
}

function selectDefaultStageset(leadId: string, defaultStagesetId: string) {
    Leads.changeStageset(leadId, defaultStagesetId).then(() => {
        document.location.reload();
    });
}
